import { Quote } from "lucide-react";

// TODO: replace these dummy testimonials post-MVP.
const items = [
  {
    quote:
      "Placeholder quote — we'll drop in a real client testimonial here once the MVP is live and we have permission to publish.",
    name: "Client name",
    role: "Head of Growth, Company",
  },
  {
    quote:
      "Placeholder quote — short, specific result-driven statement about the audit experience and impact on conversions.",
    name: "Client name",
    role: "VP Marketing, Company",
  },
  {
    quote:
      "Placeholder quote — about turnaround time, clarity of the test backlog, or quality of the senior CRO review.",
    name: "Client name",
    role: "Founder, Company",
  },
];

export function Testimonials() {
  return (
    <section className="section-pad">
      <div className="container-tg">
        <div className="max-w-2xl mb-14">
          <p className="label-eyebrow mb-4">What clients say</p>
          <h2 className="heading-h2 text-white">
            Audits that <span className="brand-grad-text">move the metric.</span>
          </h2>
          <p className="body-text mt-5 text-lg">
            Real testimonials drop in once MVP ships.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {items.map((t, i) => (
            <figure
              key={i}
              className="relative bg-[color:hsl(var(--surface))] border border-[color:hsl(var(--border))] rounded-2xl p-8 md:p-10"
            >
              <Quote size={40} className="text-[color:hsl(var(--primary))] opacity-80 mb-4" />
              <blockquote className="text-lg leading-relaxed text-white">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-6 pt-6 border-t border-[color:hsl(var(--border))]">
                <div className="font-semibold text-white">{t.name}</div>
                <div className="text-sm text-[color:hsl(var(--muted-foreground))]">{t.role}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
